"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentSetChange = exports.AgentPodEventType = exports.AgentPod = void 0;
const logging_1 = require("../../util/logging");
var AgentPodEventType;
(function (AgentPodEventType) {
    AgentPodEventType["AgentSetChange"] = "agent-set-change";
    AgentPodEventType["ConnectionStatusChange"] = "connection-status-change";
    AgentPodEventType["RemoteAddressListening"] = "remote-address-listening";
})(AgentPodEventType || (AgentPodEventType = {}));
exports.AgentPodEventType = AgentPodEventType;
;
var AgentSetChange;
(function (AgentSetChange) {
    AgentSetChange["Addition"] = "addition";
    AgentSetChange["Removal"] = "removal";
})(AgentSetChange || (AgentSetChange = {}));
exports.AgentSetChange = AgentSetChange;
;
class AgentPod {
    constructor() {
        this.agents = new Map();
    }
    // locally running agent set management
    registerAgent(agent) {
        this.agents.set(agent.getAgentId(), agent);
        agent.ready(this);
        const ev = {
            type: AgentPodEventType.AgentSetChange,
            content: {
                agentId: agent.getAgentId(),
                change: AgentSetChange.Addition
            }
        };
        this.broadcastEvent(ev);
    }
    deregisterAgent(agent) {
        this.deregisterAgentById(agent.getAgentId());
    }
    deregisterAgentById(id) {
        let agent = this.agents.get(id);
        if (agent !== undefined) {
            const ev = {
                type: AgentPodEventType.AgentSetChange,
                content: {
                    agentId: id,
                    change: AgentSetChange.Removal
                }
            };
            this.broadcastEvent(ev);
            agent.shutdown();
            this.agents.delete(id);
        }
    }
    getAgent(id) {
        return this.agents.get(id);
    }
    getAgentIdSet() {
        return new Set(this.agents.keys());
    }
    // send an event that will be received by all local agents
    broadcastEvent(ev) {
        AgentPod.logger.trace('EventPod broadcasting event ' + ev.type + ' with content ' + JSON.stringify(ev.content));
        for (const agent of this.agents.values()) {
            agent.receiveLocalEvent(ev);
        }
    }
    shutdown() {
        for (const agent of this.agents.values()) {
            agent.shutdown();
        }
    }
}
exports.AgentPod = AgentPod;
AgentPod.logger = new logging_1.Logger(AgentPod.name, logging_1.LogLevel.INFO);
//# sourceMappingURL=AgentPod.js.map